(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-buy-button"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.EverNextPlainBuyNowBound) return;
  window.EverNextPlainBuyNowBound = true;
  const sync = () => {
    document.querySelectorAll('[data-en-buy-now]').forEach((button) => {
      if (button.dataset.enPending === 'true') return;
      const add = button.closest('form')?.querySelector('button[name="add"]');
      button.disabled = !add || add.disabled;
    });
  };
  document.addEventListener('change', () => { setTimeout(sync, 0); setTimeout(sync, 150); });
  document.addEventListener('input', () => { setTimeout(sync, 0); });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-en-buy-now]').forEach((button) => {
      delete button.dataset.enPending;
      button.removeAttribute('aria-busy');
    });
    sync();
    setTimeout(sync, 150);
  });
  document.addEventListener('click', async (event) => {
    const cartAction = event.target.closest('[data-en-buy-now-add-to-cart]');
    if (cartAction) {
      event.preventDefault();
      const sticky = cartAction.closest('hdt-sticky-btn-atc[form]');
      const selectedForm = sticky ? document.getElementById(sticky.getAttribute('form')) : cartAction.closest('form');
      const selectedAdd = selectedForm?.querySelector('button[type="submit"][name="add"]');
      if (!selectedForm || !selectedAdd || selectedAdd.disabled || selectedAdd.getAttribute('aria-busy') === 'true' || !selectedForm.reportValidity()) return;
      const selectedStatus = selectedForm.querySelector('[data-en-buy-now-status]');
      if (selectedStatus) selectedStatus.hidden = true;
      selectedForm.requestSubmit(selectedAdd);
      return;
    }
    const button = event.target.closest('[data-en-buy-now]');
    if (!button) return;
    event.preventDefault();
    const form = button.closest('form');
    const status = form?.querySelector('[data-en-buy-now-status]');
    const statusText = status?.querySelector('[data-en-buy-now-message]');
    const addToCart = status?.querySelector('[data-en-buy-now-add-to-cart]');
    const reviewCart = status?.querySelector('[data-en-buy-now-review-cart]');
    const add = form?.querySelector('button[name="add"]');
    if (!form || button.disabled || !add || add.disabled || !form.reportValidity()) return;
    const desktop = matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches;
    button.dataset.enPending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) { status.hidden = true; if (statusText) statusText.textContent = ''; if (addToCart) addToCart.hidden = true; if (reviewCart) reviewCart.hidden = true; }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    let cartRequired = false;
    let discountRequired = false;
    let navigating = false;
    try {
      const data = new FormData(form);
      const ids = data.getAll('id').map(String).filter(Boolean);
      const quantity = Number(data.get('quantity') || 1);
      if (ids.length !== 1 || !/^\d+$/.test(ids[0]) || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error();
      const attributes = [];
      for (const [name, value] of data.entries()) {
        const match = /^properties\[(.+)\]$/.exec(name);
        if (!match) continue;
        if (value instanceof File) { if (value.size > 0) { cartRequired = true; throw new Error(); } continue; }
        if (String(value).trim()) attributes.push({ key: match[1], value: String(value) });
      }
      const sellingPlan = String(data.get('selling_plan') || '');
      if (sellingPlan) { cartRequired = true; throw new Error(); }
      const root = window.Shopify?.routes?.root || '/';
      const previous = await fetch(`${root}cart.js`, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!previous.ok) throw new Error();
      const current = await previous.json();
      if (!Array.isArray(current.items) || current.currency !== button.dataset.enCurrency) throw new Error();
      const discountCodes = new Map();
      const requiredCodes = new Set();
      {
        for (const entry of Array.isArray(current.discount_codes) ? current.discount_codes : []) {
          const code = typeof entry?.code === 'string' ? entry.code.trim() : '';
          if (!code) { if (entry?.applicable === true) { discountRequired = true; throw new Error(); } continue; }
          const key = code.toLowerCase();
          discountCodes.set(key, code);
          if (entry.applicable === true) requiredCodes.add(key);
        }
        const applications = [...(current.cart_level_discount_applications || []), ...current.items.flatMap((item) => (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application))];
        if (!discountCodes.size && applications.some((application) => application?.type === 'discount_code')) { discountRequired = true; throw new Error(); }
        if (!desktop && (discountCodes.size > 250 || !requiredCodes.size && applications.some((application) => application?.type === 'discount_code'))) { discountRequired = true; throw new Error(); }
      }
      const country = button.dataset.enCountry;
      if (!/^[A-Z]{2}$/.test(country || '')) throw new Error();
      const line = { merchandiseId: `gid://shopify/ProductVariant/${ids[0]}`, quantity, attributes };
      const query = 'mutation EverNextPlainBuyNow($input: CartInput) { cartCreate(input: $input) { cart { checkoutUrl cost { subtotalAmount { currencyCode } } lines(first: 2) { nodes { quantity attributes { key value } merchandise { ... on ProductVariant { id } } } } } userErrors { field message } warnings { code message } } }';
      const checkoutQuery = query.replace('checkoutUrl cost', 'checkoutUrl discountCodes { code applicable } cost');
      const input = { lines: [line], buyerIdentity: { countryCode: country } };
      if (discountCodes.size) input.discountCodes = [...discountCodes.values()];
      const response = await fetch('/api/2026-07/graphql.json', { method: 'POST', credentials: 'same-origin', signal: controller.signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: checkoutQuery, variables: { input } }) });
      if (!response.ok) throw new Error();
      const payload = await response.json();
      const created = payload.data?.cartCreate;
      if (payload.errors?.length || created?.userErrors?.length) throw new Error();
      {
        if (!Array.isArray(created?.cart?.discountCodes)) throw new Error();
        if ([...requiredCodes].some((code) => !created.cart.discountCodes.some((entry) => typeof entry.code === 'string' && entry.code.trim().toLowerCase() === code && entry.applicable === true))) { discountRequired = true; throw new Error(); }
        const discountWarnings = new Set(['DISCOUNT_CODE_NOT_HONOURED', 'DISCOUNT_CURRENTLY_INACTIVE', 'DISCOUNT_CUSTOMER_NOT_ELIGIBLE', 'DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED', 'DISCOUNT_ELIGIBLE_CUSTOMER_MISSING', 'DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE', 'DISCOUNT_NO_ENTITLED_LINE_ITEMS', 'DISCOUNT_NO_ENTITLED_SHIPPING_LINES', 'DISCOUNT_NOT_FOUND', 'DISCOUNT_PURCHASE_NOT_IN_RANGE', 'DISCOUNT_QUANTITY_NOT_IN_RANGE', 'DISCOUNT_USAGE_LIMIT_REACHED']);
        if (created?.warnings?.some((warning) => !discountWarnings.has(warning.code))) throw new Error();
      }
      const lines = created?.cart?.lines?.nodes || [];
      if (lines.length !== 1 || lines[0].merchandise?.id !== line.merchandiseId || lines[0].quantity !== quantity || created.cart.cost?.subtotalAmount?.currencyCode !== button.dataset.enCurrency) throw new Error();
      if (attributes.some((expected) => !lines[0].attributes.some((actual) => actual.key === expected.key && actual.value === expected.value))) throw new Error();
      const url = new URL(created.cart.checkoutUrl);
      if (url.protocol !== 'https:' || url.hostname !== location.hostname) throw new Error();
      url.searchParams.set('skip_shop_pay', 'true');
      navigating = true;
      location.assign(url.href);
    } catch (_error) {
      navigating = false;
      if (status) {
        if (statusText) statusText.textContent = desktop ? (discountRequired ? button.dataset.enBuyNowDesktopDiscount : cartRequired ? button.dataset.enBuyNowDesktopRequired : button.dataset.enBuyNowDesktopError) : discountRequired ? button.dataset.enBuyNowDesktopDiscount : cartRequired ? button.dataset.enBuyNowCartRequired : button.dataset.enBuyNowError;
        if (addToCart) addToCart.hidden = desktop;
        if (reviewCart) reviewCart.hidden = desktop;
        status.hidden = false;
      }
    } finally {
      clearTimeout(timeout);
      if (!navigating) {
        delete button.dataset.enPending;
        button.removeAttribute('aria-busy');
        sync();
      }
    }
  });
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
